import isParameterEmpty from "../isParameterEmpty";

const removeEmptyApiParameters = (parameters) =>
  Object.fromEntries(
    Object.entries(parameters).filter(
      ([, parameter]) => !isParameterEmpty(parameter)
    )
  );

export default removeEmptyApiParameters;
